import { type JSX, useState } from "react";

import { ManageSubscription } from "features/subscriptions/components";
import useManageSubscriptionSteps from "features/subscriptions/hooks/useManageSubscriptionSteps";

import { Dialog, DialogContent } from "common/components/ui/Dialog";
import { Drawer, DrawerContent } from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import SeatPurchase from "./SeatPurchase";

interface LicensesProps {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  noSeatAccountIds: string[];
}

export default function NotEnoughSeatsDialog({
  isOpen,
  setIsOpen,
  noSeatAccountIds,
}: LicensesProps) {
  const isDesktop = useTwBreakpoint("lg");
  const { manageSubscriptionStep, goToManageSubscriptionStep, dialogSize } =
    useManageSubscriptionSteps("user");

  const [currentStep, setCurrentStep] = useState<
    "noSeats" | "manageSubscription"
  >("noSeats");

  const Content = isDesktop ? DialogContent : DrawerContent;

  let mainComponent: JSX.Element;

  if (currentStep === "noSeats") {
    mainComponent = (
      <Content size="md" key="manage">
        <SeatPurchase
          additionalSeatsCount={noSeatAccountIds.length}
          onNext={() => setCurrentStep("manageSubscription")}
        />
      </Content>
    );
  } else {
    mainComponent = (
      <ManageSubscription
        plan="user"
        step={manageSubscriptionStep}
        goToStep={goToManageSubscriptionStep}
      />
    );
  }

  const Component = isDesktop ? Dialog : Drawer;

  return (
    <Component
      open={isOpen}
      onOpenChange={setIsOpen}
      onAfterClose={() => setCurrentStep("noSeats")}
    >
      <Content
        size={currentStep === "noSeats" ? "md" : dialogSize}
        key="manage"
      >
        {mainComponent}
      </Content>
    </Component>
  );
}
